(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '€{{amount_with_comma_separator}}';
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(pattern);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return format.replace(pattern, value);
  }

  function initProduct(section) {
    var json = section.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var inputs = section.querySelectorAll('[data-option-index]');
    var moneyFormat = section.getAttribute('data-money-format');
    var unavailableLabel = section.hasAttribute('data-coming-soon') ? 'Coming Soon' : 'Ausverkauft';

    function update() {
      var selected = [];
      inputs.forEach(function (input) {
        if (input.checked) selected[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      section.querySelectorAll('[data-selected-label]').forEach(function (el) {
        el.textContent = selected[parseInt(el.getAttribute('data-selected-label'), 10)] || '';
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      var button = section.querySelector('[data-add-button]');
      var label = section.querySelector('[data-add-label]');
      var idInput = section.querySelector('[data-variant-id]');
      var price = section.querySelector('[data-price]');
      var compare = section.querySelector('[data-compare]');

      if (!variant) {
        if (button) button.disabled = true;
        if (label) label.textContent = 'Nicht verfügbar';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'In den Warenkorb' : unavailableLabel;
      if (price) price.textContent = formatMoney(variant.price, moneyFormat);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media) {
        var gallery = section.querySelector('[data-gallery]');
        var item = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (gallery && item) {
          if (window.matchMedia('(max-width: 989px)').matches) {
            gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          } else if (item !== gallery.firstElementChild) {
            gallery.insertBefore(item, gallery.firstElementChild);
          }
        }
      }
    }

    inputs.forEach(function (input) { input.addEventListener('change', update); });
  }

  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function initCart(form) {
    form.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        form.submit();
      });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
        form.submit();
      });
      input.addEventListener('change', function () { form.submit(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    document.querySelectorAll('[data-cart-form]').forEach(initCart);

    document.querySelectorAll('[data-facet-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) form.submit();
      });
    });

    document.querySelectorAll('[data-open-dialog]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var dialog = document.getElementById(btn.getAttribute('data-open-dialog'));
        if (dialog && typeof dialog.showModal === 'function') {
          e.preventDefault();
          dialog.showModal();
        }
      });
    });

    document.addEventListener('click', function (e) {
      document.querySelectorAll('details.facet[open], details.mobile-nav[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
  });
})();
